export default class Country {
  code = ''
  name = ''
}
